import moment from 'moment'

export const ISO = 'YYYY-MM-DD'
export const RU = 'DD.MM.YYYY'

// The canonical applied range is INCLUSIVE ISO { from, to } — exactly what
// the operator sees and picks (e.g. 01.06 — 30.06 = the whole of June).
export function lastMonthRange() {
  const m = moment().subtract(1, 'month')
  return {
    from: m
      .clone()
      .startOf('month')
      .format(ISO),
    to: m
      .clone()
      .endOf('month')
      .format(ISO)
  }
}

export function getPresets() {
  const iso = d => d.format(ISO)
  return [
    { key: 'lastMonth', label: 'Прошлый месяц', ...lastMonthRange() },
    {
      key: 'thisMonth',
      label: 'Этот месяц',
      from: iso(moment().startOf('month')),
      to: iso(moment())
    },
    {
      key: 'last7',
      label: 'Последние 7 дней',
      from: iso(moment().subtract(6, 'days')),
      to: iso(moment())
    },
    {
      key: 'last30',
      label: 'Последние 30 дней',
      from: iso(moment().subtract(29, 'days')),
      to: iso(moment())
    },
    {
      key: 'yesterday',
      label: 'Вчера',
      from: iso(moment().subtract(1, 'day')),
      to: iso(moment().subtract(1, 'day'))
    },
    { key: 'today', label: 'Сегодня', from: iso(moment()), to: iso(moment()) }
  ]
}

// Backend filters created_at with { $gte: startDate, $lt: endDate } — endDate
// is EXCLUSIVE — and parses DD.MM.YYYY. So the exclusive end we send is the
// inclusive end + 1 day.
export function toGraphqlRange({ from, to }) {
  return {
    startDate: moment(from, ISO).format(RU),
    endDate: moment(to, ISO)
      .add(1, 'day')
      .format(RU)
  }
}

export function formatPeriod({ from, to }) {
  return `${moment(from, ISO).format(RU)} — ${moment(to, ISO).format(RU)}`
}
